import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'checkbox-component',
    template: '<input type="checkbox" [checked]="false" (change)="onChange($event)">'
})
export class CheckboxRendererComponent implements ICellRendererAngularComp {
  private params: ICellRendererParams;

  constructor() {}

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  public onChange(event): void {
    this.params.data[this.params.colDef.field] = event.currentTarget.checked;
  }

  refresh(params: ICellRendererParams): boolean {
    return true;
  }
}
